import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import { __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import { useForm as useForm$1 } from 'rc-field-form';
import scrollIntoView from 'scroll-into-view-if-needed';
import getFieldId from '../common/getFieldId.js';
import useFormPubSub from './useFormPubSub.js';

function useForm(form) {
  var pubSub = useFormPubSub();
  var rcForm = useForm$1()[0];
  var wrapForm = React.useMemo(function () {
    return form !== null && form !== void 0 ? form : __assign(__assign({}, rcForm), {
      TI_FORM_INTERNAL: {
        pubSub: pubSub
      },
      scrollToField: function scrollToField(name, options) {
        if (options === void 0) {
          options = {};
        }
        var fieldId = getFieldId(name, wrapForm.TI_FORM_INTERNAL.name);
        var node = document.getElementById(fieldId);
        if (node) {
          scrollIntoView(node, __assign(__assign({}, options), {
            scrollMode: 'if-needed',
            behavior: 'smooth'
          }));
        }
      }
    });
  }, [form, rcForm]);
  return [wrapForm];
}

export { useForm as default };
